export const stripTagClientSide = (dirtyText: string): string => {
  const tag = window.document.createElement("div")
  tag.innerHTML = dirtyText
  return tag.textContent || ""
}
